import { render, staticRenderFns } from "./AdminHistoryActivity.vue?vue&type=template&id=536d6256&scoped=true"
import script from "./AdminHistoryActivity.vue?vue&type=script&lang=js"
export * from "./AdminHistoryActivity.vue?vue&type=script&lang=js"
import style0 from "./AdminHistoryActivity.vue?vue&type=style&index=0&id=536d6256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536d6256",
  null
  
)

export default component.exports